<template>
    <div>
        <!-- metodos de pago -->
        <div class="mt-5 border p-3 mb-5">
        <h2 class="h3 mb-3 mt-3 text-black">
            M&eacute;todo de Pago
        </h2>
        <nav class="nav nav-pills nav-justified align-items-center">
          <!-- Stripe -->
          <a
            type="button"
            id="btnStripe"
            class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5 activeTab"
            @click="paymentType(6)"
            ><img
              src="images/img_estilos/stripe.png"
              alt="Stripe"
              loading="lazy"
              style="width: 85px; height: 40px; object-fit: contain"
          /></a>
            <!-- Openpay -->
            <a 
            type="button"
            id="btnOpenPay"
            class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5" 
            @click="paymentType(5)">
            <img src="images/img_estilos/btnOpenPay.png" 
            alt="Openpay"
            loading="lazy"
            style="width: 85px; height: 40px; object-fit:contain;">
            </a>
            <!-- Paypal -->
            <!-- <a
            v-if="paypalIsActive"
            type="button"
            id="btnPaypal"
            class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5"
            @click="paymentType(4)"
            ><img src="images/img_estilos/btnPaypal.png"
            alt="Paypal"
            loading="lazy"
                style="width: 85px; height: 40px; object-fit:contain;"
            /></a> -->
        </nav>
        </div>
        <!-- end -->
        <!-- Stripe -->
        <div v-show="is_stripe" id="sripe-method">
          <div class="py-2">
            <p class="mb-0">
              Realiza tu pago desde stripe. Stripe te
              redireccionar&aacute; de regreso a &eacute;sta p&aacute;gina cuando tu
              pago este completado. Tu orden ser&aacute; enviada una vez que tu pago
              sea confirmado.
            </p>
          </div>
          <!-- Stripe -->
        </div>
        <!-- Paypal -->
        <div>
          <div v-show="is_paypal">
              <div class="py-2 mb-4">
              <p class="mb-0">
                  Realiza tu pago desde tu cuenta de paypal. Paypal te
                  redireccionar&aacute; de regreso a &eacute;sta
                  p&aacute;gina cuando tu pago este completado. Tu orden
                  ser&aacute; enviada una vez que tu pago sea
                  confirmado.
              </p>
              </div>
          </div>
        </div>
        <!-- OpenPay -->
        <div>
        <div v-show="is_openpay">
            <div class="tab-content px-3 px-md-4">
            <div>
                <div class="py-0">
                <div class="form" id="op_processCard">
                    <div class="row">
                    <div class="col-12">
                        <p class="pb-2 mb-sm-2 text-center text-muted">Acepta pagos de tarjetas de crédito y débito por medio de OpenPay</p>
                    </div>
                    <div class="col-12">
                        <a class="btn btn-info mb-5 py-2" data-toggle="collapse" href="#collapseCards" role="button" aria-expanded="false" aria-controls="collapseExample">
                            Tarjetas aceptadas ↕
                        </a>
                    </div>
                    <div class="collapse" id="collapseCards">
                        <div class="col-12">
                        <p class="mb-1 mb-sm-2 text-left">
                            Tarjetas de Crédito
                        </p>
                        <div class="row mb-4 align-items-center">
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/visa.png" alt="Visa" class="img-responsive img-fluid" width="40px" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/masterCard.png" alt="MasterCard" class="img-responsive img-fluid" width="40px" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/carnet.png" alt="Carnet" class="img-responsive img-fluid" width="90px" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/americanExpress.png" alt="American Express" class="img-responsive img-fluid" width="35px" height="auto"></div>
                        </div>
                        </div>
                        <div class="col-12">
                        <p class="text-left">Tarjetas de Débito</p>
                        <div class="row mb-4 align-items-center">
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/hsbc.jpeg" alt="HSBC" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/scotiabank.png" alt="Scotiabank" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/citibanamex.png" alt="Citibanamex" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bbva.png" alt="BBVA" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/santander.png" alt="Santander" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/ixe.png" alt="Ixe" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bancoAzteca.png" alt="Banco Azteca" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/inbursa.png" alt="Inbursa" class="img-responsive img-fluid" height="auto"></div>
                        </div>
                        </div>
                        <div class="col-12">
                        <p class="text-left">Tarjetas de crédito a meses sin intereses</p>
                        <div class="row mb-4 align-items-center">
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bbva.png" alt="BBVA" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/citibanamex.png" alt="Citibanamex" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/inbursa.png" alt="Inbursa" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/santander.png" alt="Santander" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/monex.png" alt="Grupo Financiero Monex" class="img-fluid" height="auto"></div>                  
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/afirme.png" alt="Afirme" class="img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/banorte.png" alt="Banorte" class="img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_openPay/banRegio.png" alt="BanRegio" class="img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/hsbc.jpeg" alt="HSBC" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/scotiabank.png" alt="Scotiabank" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/americanExpress.png" alt="American Express" class="img-responsive img-fluid" width="35px" height="auto"></div>
                        </div>
                        </div>
                        <div class="col-12">
                        <p class="text-left">Puntos Bancarios</p>
                        <div class="row mb-4 align-items-center">
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/bbva.png" alt="BBVA" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/scotiabank.png" alt="Scotiabank" class="img-responsive img-fluid" height="auto"></div>
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/santander.png" alt="Santander" class="img-responsive img-fluid" height="auto"></div>
                        </div>
                        </div>
                        <div class="col-12">
                        <p class="text-left">Tarjetas de servicio</p>
                        <div class="row mb-4 align-items-center">
                            <div class="col-4 col-md-4 col-lg-3"><img loading="lazy" src="images/img_Cards/upSivale.png" alt="Up SiVale" class="img-responsive img-fluid" height="auto"></div>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div class="form-group">
                    <input type="text" name="openpay_holder_name" id="openpay_holder_name" class="form-control" placeholder="Nombre en la tarjeta" data-openpay-card="holder_name">
                    </div>
                    <div class="form-row mb-3">
                    <div class="col-10">
                        <input type="text" maxlength="16" name="openpay_card_number" id="openpay_card_number" class="form-control" placeholder="Número de la tarjeta" data-openpay-card="card_number">
                    </div>
                    <div class="col-2">
                        <input type="text" name="openpay_card_cvv" maxlength="4" id="openpay_card_cvv" class="form-control" placeholder="***" data-openpay-card="cvv2">
                    </div>
                    </div>
                    <div class="form-row">
                    <div class="col-6">
                        <select name="openpay_card_month" id="openpay_card_month" data-openpay-card="expiration_month" class="form-control">
                        <option value="0">.: Elige el mes :.</option>
                        <option v-for="month in card_months" :value="month">{{ month }}</option>
                        </select>
                    </div>
                    <div class="col-6">
                        <select name="openpay_card_year" id="openpay_card_year" data-openpay-card="expiration_year" class="form-control">
                        <option value="0">.: Elige el año :.</option>
                        <option v-for="year in card_years" :value="year.toString().substr(-2)">{{ year }}</option>
                        </select>
                    </div>
                    </div>
                    <div class="form-group my-5" v-if="total >= 1000">
                    <small class="text-left d-block" style="color:red;">Pago a meses solo a partir de $1000 </small>
                    <select name="months_to_pay" id="months_to_pay" v-model="months" class="form-control"
                    >
                        <option value="0">.: Pago a meses :.</option>
                        <option value="3">3 meses</option>
                        <option value="6">6 meses</option>
                        <option value="9">9 meses</option>
                    </select>
                    </div>
                    <input type="hidden" data-openpay-card-address="line1" :value="addressData.street">
                    <input type="hidden" data-openpay-card-address="line2" :value="addressData.no_ext">
                    <input type="hidden" data-openpay-card-address="line3" :value="addressData.references">
                    <input type="hidden" data-openpay-card-address="postal_code" :value="addressData.cp">
                    <input type="hidden" data-openpay-card-address="city" :value="addressData.state">
                    <input type="hidden" data-openpay-card-address="state" :value="addressData.state">
                    <input type="hidden" data-openpay-card-address="country_code" value="MX">
                    <input type="hidden" name="token_id" id="token_id">
                </div><!-- .form -->
                </div>
            </div>
            </div>
        </div><!-- Openpay -->
        </div>
        <div class="form-group pt-2" v-if="is_login">
            <loading :active.sync="is_loading"></loading>
            <button
            @click="placeOrder"
            :disabled="desactivar"
            class="btn btn-success btn-lg py-3 btn-block"
            >
            Procede al pago
            </button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//import axios from "axios"
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
const axios = require("axios");
import { eventBus } from "./../../events.js";

export default {
    name: "PaymentMethodsOneClick",
    props: ['addressData','accessLogin'],
    components: {
    Loading,
  },
  data() {
    return {
      
      form: {
        street: "",
        no_ext: "",
        suburb: "",
        municipality: "",
        state: "",
        cp: "",
        btw_streets: "",
        references: "",
        isEdit: false,
      },
      is_loading: false,
      desactivar: false,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
      openpay_id: process.env.VUE_APP_OPENPAY_ID,
      openpay_key: process.env.VUE_APP_OPENPAY_APIKEY,
        is_sandbox_mode: process.env.VUE_APP_SANDBOX_MODE,
      is_login: false,
      cardData: {
        card_name: "",
        card_number: "",
        card_cvv: "",
        card_exp: "",
      },
      subtotal: 0,
      total: 0,
      iva: 0,
      is_paypal: false,
      is_openpay: false,
      is_stripe: true,
      is_openpay_cards:true,
      conekta_token: "",
      months: 0,
      sent_cost: false,
      sending_cost: 65,
      card_months: [],
      card_years: [],
      showTotal: false,
      receiver: {
        name: "",
      },
      openPayCustomerId: null,
      deviceSessionId: null,
      successSendDataPaypal: null,
      userData: null,
      paypalIsActive: true
    };
  },
  filters: {
    pesos: function (number) {
      return new Intl.NumberFormat("es-MX").format(number);
    },
  },
  mounted(){
    // se verifica que en los productos no exista alguno con suscripcion recurrente a 2 años
    console.error("producto: ", this.products);
    for (let x = 0; x < this.products.length; x++) {
      if(this.products[x].id === 30 || this.products[x].id === 1){
        this.paypalIsActive = false;
      }
    }

    console.log('payment montando');
    if(this.accessLogin){
      this.is_login = true;
    }
    console.log('secret id paypal');
    if(Object.keys(this.$route.params).length === 0){
      console.log('no se enviaron los parametros');
      this.$router.push({name:"home"});
    }
    else{
      console.log('existen los parametros');
    }
    let openpay_script = document.createElement("script");
    openpay_script.setAttribute('src', 'https://js.openpay.mx/openpay.v1.min.js');
    document.head.appendChild(openpay_script);
    let openpay_data_script = document.createElement("script");
    openpay_data_script.setAttribute('src', 'https://js.openpay.mx/openpay-data.v1.min.js');
    document.head.appendChild(openpay_data_script);

    console.log(this.$route.params);
  },
  created() {
    console.log('payment creado');

    eventBus.$on("tokenSet", (token) => (this.utoken = token));
    const script = document.createElement("script");
    script.src = "https://cdn.conekta.io/js/latest/conekta.js";
    script.async = true;
    document.body.appendChild(script);

    // Se verifica si el usuario esta logeado
    if ($cookies.isKey("utoken")) {
      this.is_login = true;
      axios({
        method: "GET",
        url: this.api_url + "/subscribers/" + $cookies.get("uidmmkg"),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.userData = response.data;

          this.receiver.name =
            this.userData.name +
            " " +
            this.userData.lastname +
            " " +
            this.userData.surname;
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
    }

    this.products = this.$store.state.cartSubscription;
    this.updateOrder();

    this.card_months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];
    this.card_years.push(2022);
    this.card_years.push(2023);
    this.card_years.push(2024);
    this.card_years.push(2025);
    this.card_years.push(2026);
    this.card_years.push(2027);
    this.card_years.push(2028);
    this.card_years.push(2029);
    this.card_years.push(2030);
    this.card_years.push(2031);
    this.card_years.push(2032);
    this.card_years.push(2033);
    console.log("Checar costo de envio");
    console.log(this.products);
    axios({
      method: "POST",
      url: this.api_url + "/shipping-fee/verify",
      data: {
        items: this.products,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + $cookies.get("ctoken"),
      },
    })
      .then((response) => {
        console.log("El costo de envio");
        console.log(response.data.fee);

        if (response.data.fee > 0) {
          this.sent_cost = true;
          this.sending_cost = response.data.fee;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  watch: {
    is_stripe(newVal, oldVal){
      (newVal === false) ? document.querySelector("#btnStripe").classList.remove('activeTab') 
      : document.querySelector("#btnStripe").classList.add('activeTab');
    },
    is_paypal(newVal, oldVal){
      (newVal === false) ? document.querySelector("#btnPaypal").classList.remove('activeTab') 
      : document.querySelector("#btnPaypal").classList.add('activeTab');
    },
    is_openpay(newVal, oldVal){
      (newVal === false) ? document.querySelector("#btnOpenPay").classList.remove('activeTab') 
      : document.querySelector("#btnOpenPay").classList.add('activeTab');
    }
  },
  methods: {
    changeView: function (value) {
      this.showTotal = value;
    },
    getdirections() {
      axios.get(this.url).then((data) => {
        this.directions = data.data;
      });
    },
    updateAddress: function (value) {
      console.info("Actualizando direccion en Checkout");
      console.info(value);
      this.addressData = value;
    },
    
    placeOrder: function () {
      this.desactivar = true;
      this.is_loading = true;

      if (this.receiver.name.length === 0 || this.receiver.name === "") {
        this.receiver.name =
          this.userData.name +
          " " +
          this.userData.lastname +
          " " +
          this.userData.surname;
      }

      if (this.months == 0) {
        this.months = 1;
      }
      console.log('checando addresData', this.addressData);
      if (jQuery.isEmptyObject(this.addressData)) {
        this.desactivar = false;
        this.$snotify.warning(
          "Falta la dirección de envío. Selecciona o registra una dirección de envío"
        );
        
        this.is_loading = false;
        } else {
          if (this.is_stripe) {
            console.log('envio de data stripe');
            this.sendDataStripe();
          } else if (this.is_paypal) {
            console.log('envio de data paypal');
            this.sendDataPaypal();
          } else if (this.is_openpay){
            if(this.is_openpay_cards){
              this.sendDataOpenpay();
            }
        }
      }
    },
    updateOrder: function () {
      var suma = 0;
      var tiene_costo = false;

      this.products.forEach(function (item) {
        suma += item.quantity * item.price;
        if (item.type_id === 2 || item.type_id === 3) {
          tiene_costo = false;
        } else {
          tiene_costo = true;
        }

      });
      this.subtotal = suma;
      this.total = this.$route.params.price;
    },
    paymentType: function (type) {
      switch (type) {

        case 6:
          this.is_openpay = false;
          this.is_paypal = false;
          this.is_stripe = true;
          break;

        case 5:
          this.is_openpay = true;
          this.is_paypal = false;
          this.is_stripe = false;
          break;

        case 4:
          this.is_openpay = false;
          this.is_paypal = true;
          this.is_stripe = false;
          break;
      }
    },
    sendDataStripe: function(){
        axios({
        method: "POST",
        url: this.api_url + "/payment/stripe/subscription",
        data: {
          user_id: $cookies.get("uidmmkg"),
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
          success_url: this.local_url + "/thanksStripe?session_id={CHECKOUT_SESSION_ID}",
          //success_url: "http://localhost:8080/" + "/thanksStripe?session_id={CHECKOUT_SESSION_ID}",
          cancel_url: this.local_url,
          months: this.months,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          console.info("suscripcion por stripe: ", response.data);
          this.desactivar = false;
          console.info(response);
          if (response.data.status) {
            console.info("respuesta stripe: ", response.data);

            this.$store.commit('saveSeveralProducts', this.products);
            window.dataLayer.push({
                'event': 'Pago',
                'pageURL': this.$router.currentRoute.fullPath,
                'subscription': this.products,
                'months': this.months,
                'address': this.addressData,
                'paymentMethod': "Cargo de producto realizado por Stripe",
                'datePayment': new Date().toLocaleString('en-US')
            });

            this.$snotify.info("Redirigiendo a Stripe");
            window.location.href = response.data.redirect_url;
          } else {
            this.$snotify.error(response.data.message);
          }
          this.is_loading = false;

        })
        .catch((error) => {
          console.error(error);
          this.desactivar = false;
          this.is_loading = false;
          this.$snotify.error(error);
        });
    },
    sendDataPaypal: function () {
      console.log('address',this.addressData);
      // Funcion para realizar el cargo a paypal
      axios({
        method: "POST",
        url: this.api_url + "/paypal/subscription-payment",
        data: {
          user_id: $cookies.get("uidmmkg"),
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
          success_url: this.local_url + "/thanksPaypal",
          cancel_url: this.local_url,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.desactivar = false;
          if (response.status) {

          window.dataLayer.push({
                'event': 'Pago',
                'pageURL': this.$router.currentRoute.fullPath,
                'subscription': this.products,
                'months': "",
                'address': this.addressData,
                'paymentMethod': "Cargo de producto realizado por Paypal",
                'datePayment': new Date().toLocaleString('en-US')
            });

            console.info('Suscripcion con paypal');
            console.info(response);
            this.$snotify.info("Redirigiendo a Paypal");
              this.$router.push({
                  name: "thanksForPay",
                  params: {
                      product: this.products
                  },
              });
              setTimeout(() => {
                if(response.data.approval_url == "undefined"){
                  this.$snotify.error("Sucedió un error en la transacción");
                  this.desactivar = false;
                this.is_loading = false;
                }else{
                  window.location.href = response.data.approval_url;
                }
              }, 3000);
          } else {
            this.$snotify.error("Sucedió un error al enviar los datos");
          }
          this.is_loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.desactivar = false;
          this.is_loading = false;
          this.$snotify.error(error);
        });
    },
    sendDataOpenpay: function(){
      this.desactivar = true;
      try{
        // OpenPay.setId('m0mglvvud0ziko006r1l');
        // OpenPay.setApiKey('pk_a4c364b0775f4d5f82ff8d11a0e33775');
          OpenPay.setId(this.openpay_id);
          OpenPay.setApiKey(this.openpay_key);
        this.deviceSessionId = OpenPay.deviceData.setup('op_processCard', 'deviceIdHiddenFieldName');
        if(this.deviceSessionId === null || this.deviceSessionId === undefined || this.deviceSessionId === ""){
          this.is_loading = false;
          this.$snotify.error("Error al intentar hacer el pago");
        }
        OpenPay.setSandboxMode(this.is_sandbox_mode);
        if(!OpenPay.card.validateCardNumber($('#openpay_card_number').val())){
          this.$snotify.error("El número de tarjeta no es valido");
          this.is_loading = false;
          this.desactivar = false;
        } else if(!OpenPay.card.validateCVC($('#openpay_card_cvv').val())){
          this.$snotify.error("El código CVC no es valido");
          this.is_loading = false;
          this.desactivar = false;
        } else if(!OpenPay.card.validateCVC($('#openpay_card_cvv').val(), $('#openpay_card_number').val())){
          this.$snotify.error("El código CVC no es valido para la tarjeta ingresada");
          this.is_loading = false;
          this.desactivar = false;
        }else{
          OpenPay.token.extractFormAndCreate($('#op_processCard'), this.successOpenpay, this.errorOpenpay, this.openPayCustomerId);
        }
      }catch(error){
          this.$snotify.error("Error al intentar hacer el pago");
          this.desactivar = false;
          this.is_loading = false;
      }
    },
    successOpenpay: function(response){
      console.info("Respuesta correcta de Openpay");
      console.info(response);
      $('#token_id').val(response.data.id);
      axios({
        method: 'POST',
        url: this.api_url + '/payment/openpay-subscription',
        data: {
          user_id: $cookies.get("uidmmkg"),
          token: response.data.id,
          months: this.months,
          items: this.products,
          address: this.addressData,
          receiver: this.receiver,
          deviceIdHiddenFieldName: this.deviceSessionId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      }).then((response) => {
        console.info("respuesta de pago en servidor");
        console.info(response);
        if(response.data.status){

          window.dataLayer.push({
                'event': 'Pago',
                'pageURL': this.$router.currentRoute.fullPath,
                'subscription': this.products,
                'months': this.months,
                'address': this.addressData,
                'paymentMethod': "Cargo de producto realizado por OpenPay Tarjetas",
                'datePayment': new Date().toLocaleString('en-US')
            });

          this.$snotify.info("Procesando tu compra....");
          console.log(response)
          setTimeout(() => {
            this.$router.push({
                name: "thanksForSubscribing",
                params: {
                    orden: response.data.payment.order,
                    validate: true,
                    products: this.products
                },
            });
            this.desactivar = false;
            this.is_loading = false;
          }, 3000);
        }else{
          this.$snotify.warning(response.data.message);
        }
      }).catch( (error) => {
            console.log("Error en la suscripcion");
            console.log(error.response.data)
          this.is_loading = false;
          this.desactivar = false;
          this.$snotify.error(error);
      });
    },
    errorOpenpay: function(response){
      console.log("Error en validación de pago en Openpay")
      console.error(response);
      this.$snotify.error(response.message);
      this.is_loading = false;
      this.desactivar = false;
    },
  },

  onEdit(data) {
    //window.console.log("add edit" + data);
    this.form = data;
    this.form.isEdit = true;
  },
};
</script>

<style scoped>
.alert-warning {
  color: #856404 !important;
  background-color: #fff3cd !important;
  border-color: #ffeeba !important;
}
a.openPay:hover{
  color:#000000;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #000000;
    background-color: #e1e1e1;
    border-color: #dee2e6 #dee2e6 #fff;
}
img{
    image-rendering:-webkit-optimize-contrast; /* Safari         */
    image-rendering:optimize-contrast;         /* CSS3 Proposed  */
    -ms-interpolation-mode:nearest-neighbor;   /* IE8+           */
}
.nav-item.activeTab{
    box-shadow: 0 5px 20px -7px rgb(0 0 0 / 90%) !important;
    top: -2px;
}
</style>